import { render, staticRenderFns } from "./RemoteVar.vue?vue&type=template&id=0b6395cc&scoped=true&"
import script from "./RemoteVar.vue?vue&type=script&lang=js&"
export * from "./RemoteVar.vue?vue&type=script&lang=js&"
import style0 from "./RemoteVar.vue?vue&type=style&index=0&id=0b6395cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6395cc",
  null
  
)

export default component.exports